import { render, staticRenderFns } from "./messageBodyListPlant.vue?vue&type=template&id=2f88d619&scoped=true&"
import script from "./messageBodyListPlant.vue?vue&type=script&lang=js&"
export * from "./messageBodyListPlant.vue?vue&type=script&lang=js&"
import style0 from "./messageBodyListPlant.vue?vue&type=style&index=0&id=2f88d619&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88d619",
  null
  
)

export default component.exports